import { NOW_MARKER_ATTRIBUTE } from "./NowButton";

/**
 * The red current-time line across today's day column, with a dot at its
 * leading edge. Purely visual: it never takes pointer events, so drags and
 * drag-create pass straight through.
 */
export function NowLine({ top }: { top: number }) {
  return (
    <div
      className="pointer-events-none absolute inset-x-0 z-[12] h-0.5 -translate-y-1/2 bg-calendar-now"
      style={{ top }}
      aria-hidden
      data-testid="now-line"
      {...{ [NOW_MARKER_ATTRIBUTE]: "" }}
    >
      <span className="absolute top-1/2 left-0 size-2.5 -translate-y-1/2 rounded-full bg-calendar-now" />
    </div>
  );
}
